<template>
  <div class="profile-main">
    <div class="profile-main__title">Профиль компании</div>
    <Main
      v-if="currencies"
      :currencies="currencies" />
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";

export default {
  name: "AccountProfile",

  components: {
    Main: () => import('./components/Main.vue'),
  },

  metaInfo () {
    return {
      title: `Профиль компании - Личный кабинет дилера - ${this.getDealerName}`,
    }
  },

  computed: {
    ...mapState({
      currencies: state => state.user.currencies,
      configAccess: state => state.user.configAccess,
    }),

    ...mapGetters('user', [
      'getDealerName',
    ]),
  },

  methods: {
    ...mapActions('user', [
      'setCurrencies',
    ]),
  },

  created() {
    this.setCurrencies();
  }
}
</script>

<style scoped lang="scss">
.profile-main {
  &__title {
    font-weight: bold;
    font-size: 24px;
    line-height: 30px;
    position: fixed;
    z-index: 120;
    left: 50%;
    transform: translateX(-50%);
    top: 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    height: 53px;
    margin: 0;

    @media(max-width: $desktop) {
      position: static;
      height: auto;
      transform: translateX(0);
      margin-bottom: 11px;
    }
  }
}
</style>
